export default {
  superDesktop: '超级管理面板',
  home: '家',
  people: '人',
  directory: '目录',
  lists: '列表',
  roles: '角色',
  segments: '段',
  businesses: '企业',
  talk: '说话',
  chats: '聊天',
  conversationMetrics: '指标',
  conversationSettings: '聊天配置',
  communicate: '沟通',
  campaigns: '活动',
  triggers: '触发器',
  notifications: '通知',
  connect: '连接',
  authenticator: '身份验证器',
  forms: '形式',
  oAuths: '奥茨',
  crm: 'Crm',
  /* events */
  events: '事件',
  myEvents: '我的活动',
  categories: '类别',
  assistants: '助理',
  promotors: '专业电机',
  djs: 'Djs',
  productsCategories: '产品分类',
  products: '产品',
  places: '地方',
  /* ORDERS */
  clients: '客户',
  colors: '颜色',
  containerTypes: '容器类型',
  purchases: '购买 ',
  sellers: '卖家',
  suppliers: '供应商',
  /* microsites */
  microSites: '微型网站',
  configure: '配置',
  generalities: '泛泛而谈',
  apps: '应用程序',
  administrators: '管理员',
  billing: '计费',
  graphicAspect: '图形方面',
  automate: '自動化',
  following: '以下',
  mainTables: '主表',
  panel: '面板',
  journeyLeads: '旅途線索',
  sequences: '順序',
  userConfiguration: '用戶配置'
}
